import { loadMinicart, openMinicart } from '../components/minicart';
import './../../styles/templates/wishlist.scss';

(function (window, $) {
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }

  const wishlistRender = function (products) {
    $(function () {
      const shareBtn = document.querySelector('.wishlist-page__share');
      const shareModal = document.querySelector('.wishlist-page__share-modal');
      if (shareBtn && shareModal) {
        shareModal
          .querySelectorAll(
            '.wishlist-page__share-modal-backdrop, .wishlist-page__share-modal-close',
          )
          .forEach((closeTrigger) => {
            closeTrigger.addEventListener('click', () => {
              shareModal.classList.remove('open');
            });
          });

        shareBtn.addEventListener('click', () => {
          shareModal.classList.add('open');
        });

        _swat.generateSharedListURL(
          null,
          (link, lid) => {
            const manualLink = shareModal.querySelector(
              '[data-share-use="copy"] span',
            );
            const hiddenManualLink = shareModal.querySelector(
              '[data-share-use="copy"] #copy-link',
            );
            manualLink.innerText = link.slice(0, 40) + ' ...';
            hiddenManualLink.value = link;

            const emailLink = shareModal.querySelector(
              'a[data-share-use="email"]',
            );
            if (emailLink) {
              emailLink.href = `mailto:?subject=My Wishlist&body=Check out some of my favorite things @Manebí.%0D%0A%0D%0A${link}`;
            }
          },
          (error) => {
            console.log('Error while generating the link', error);
          },
        );

        shareModal
          .querySelectorAll(
            '[data-share-use][data-sharer][data-share-template]:not([data-share-use="copy"]):not([data-share-use="email"])',
          )
          .forEach((socialShare) => {
            socialShare.addEventListener('click', () => {
              _swat.shareListSocial(
                null,
                socialShare.dataset.sharer,
                socialShare.dataset.shareTemplate,
                socialShare.dataset.shareUse,
                'Check out some of my favorite things @Manebí.',
                (error) => {
                  console.log(
                    'There was an Error opening the share platform',
                    error,
                  );
                },
              );
            });
          });
      }

      var template = $('[data-wishlist-template]');
      var empty_template = $('[data-wishlist-empty]');
      var $wishlistContainer = $('#wishlist-content');

      var startLoading = function ($context) {
        if ($context) {
          $context.addClass('loading');
        } else {
          $wishlistContainer.addClass('loading');
        }
      };

      var stopLoading = function ($context) {
        if ($context) {
          $context.removeClass('loading');
        } else {
          $wishlistContainer.removeClass('loading');
        }
      };

      if (!products || products.length < 1) {
        $wishlistContainer.hide();
        empty_template.removeClass('hidden');
        return;
      }

      products.forEach(function (p) {
        var row = template.clone();
        const pTitle = p.dt.replaceAll('|', '<br/>').split('-');
        row.removeClass('hidden');
        row.find('[data-name]').html(pTitle[0]);
        row.find('[data-vendor]').html(p.bt);
        row.find('[data-url]').attr('href', p.du);
        row.find('[data-image]').attr('src', p.iu);
        // Price will be updated with live currency in the fetch callback below

        row.find('[data-remove]').on('click', function (e) {
          e.preventDefault();
          startLoading(row);

          _swat.removeFromWishList(p, function callback() {
            row.remove();
            window.loadWishlistBubble(0);
            stopLoading(row);
          });
        });

        $wishlistContainer.append(row);

        fetch(`${p.du}.js`)
          .then((res) => res.json())
          .then((data) => {
            if (!data) return;
            const selectedVariant = data.variants.find(
              (variant) => variant.id === p.epi,
            ) || data.variants[0];
            row.find('[data-variant-id]').val(p.epi);

            const livePrice = selectedVariant.price;
            const liveComparePrice = selectedVariant.compare_at_price;
            row.find('[data-price]').html(window.theme.Currency.formatMoney(livePrice, window.theme.strings.moneyFormat));
            if (liveComparePrice && liveComparePrice > livePrice) {
              const percentage = Math.round((livePrice * 100) / liveComparePrice, 2);
              row.find('[data-percentage-value]').html(percentage);
              row.find('[data-percentage-wrapper]').removeClass('hidden');
              row.find('[data-price-container]').addClass('strike-price');
              row.find('[data-original-price]').html(window.theme.Currency.formatMoney(liveComparePrice, window.theme.strings.moneyFormat));
            }
            const form = row.find('[data-form]');
            data.options.forEach((option) => {
              const newOption = form.find('[data-option-wrapper]').clone();
              newOption
                .find('[data-option-name]')
                .text(window.languages[option.name.toLowerCase()]);
              const select = newOption.find('[data-option-select]');
              const optionName = `option${option.position}`;
              select.attr('name', optionName);
              select.val(selectedVariant[optionName]);
              data.variants.forEach((variant) => {
                const selectOption = document.createElement('option');
                selectOption.value = variant.option1;
                selectOption.innerText = !variant.available ? variant.option1 + ' - ' + window.languages.productFormSoldOut.toUpperCase() : variant.option1;
                selectOption.disabled = !variant.available ? true : false;
                selectOption.selected = variant.option1 == p.vi ? true : false;
                select.append(selectOption);
              });
              newOption.removeClass('hidden');
              form.append(newOption);
            });

            form.on('change', function () {
              const selectedValues = Array.prototype.slice
                .call(form[0].querySelectorAll('[data-option-select][name]'))
                .map((select) => {
                  return {
                    index: select.name,
                    value: select.value,
                  };
                });
              const newVariant = data.variants.find((variant) => {
                return selectedValues.every(
                  (selectedValue) =>
                    variant[selectedValue.index] === selectedValue.value,
                );
              });
              form.find('[data-variant-id]').val(newVariant.id);

              const formError = form.find('[data-form-error]');
              setTimeout(() => {
                formError.slideUp();
              }, 5000);
            });

            form.on('submit', function (e) {
              e.preventDefault();
              ShopifyAPI.addItemFromForm(
                this,
                async (line_item) => {
                  await loadMinicart();
                  openMinicart();
                },
                (XMLHttpRequest, textStatus) => {
                  const formError = form.find('[data-form-error]');
                  formError.text(XMLHttpRequest.responseJSON.description);
                  formError.slideDown();
                  setTimeout(() => {
                    formError.slideUp();
                  }, 5000);
                },
              );
            });
            form.removeClass('hidden');
          });
      });
    });
  };

  window.SwymCallbacks.push(function () {
    _swat.fetchWrtEventTypeET(function (products) {
      wishlistRender(products);
    }, _swat.EventTypes.addToWishlist);
  });

  var copyLinkButton = $('[data-share-use="copy"] span');
  copyLinkButton.each(function () {
    wishlistShareLink($(this));
  });

  function wishlistShareLink(sharelink) {

    sharelink.on('click', function (e) {
      var copyText = document.getElementById("copy-link");
      var copiedPopup = document.querySelector('.wishlist-page__share-modal-share__popup-copied');
      if (copyText) {
        copyText.select();
        copyText.setSelectionRange(0, 99999);
        navigator.clipboard.writeText(copyText.value);

        if (copiedPopup) {
          console.log('copiedPopup');
          copiedPopup.style.opacity = '1';

          setTimeout(() => {
            copiedPopup.style.opacity = '0';
          }, 3000);
        }
      }

    });
  }

})(window, jQuery);
